import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { declineApprovalRequest } from "../../../actions/friend";
import { declineApprovalRequestNotification } from "../../../actions/notification";

const DeclineApproval = ({
  match,
  declineApprovalRequest,
  setdeclineapprovalrequest,
  declineApprovalRequestNotification,
  profile: { user, avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setdeclineapprovalrequest({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to decline the{" "}
            <span className="blue bold">Approval</span> from{" "}
            <span className="blue bold">
              {firstname} {lastname}?
            </span>
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-blue"
              onClick={() =>
                declineApprovalRequest({ user }) &&
                declineApprovalRequestNotification(match.params.channelid) &&
                setdeclineapprovalrequest({ request: false, confirm: true })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-blue"
              onClick={() =>
                setdeclineapprovalrequest({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

DeclineApproval.propTypes = {
  auth: PropTypes.object.isRequired,
  declineApprovalRequest: PropTypes.func.isRequired,
  declineApprovalRequestNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps, {
  declineApprovalRequest,
  declineApprovalRequestNotification,
})(DeclineApproval);
